/**
 * Safe breadcrumb wrapper for Sentry.
 *
 * Purpose: Ensures that instrumentation calls never crash the application.
 * Sentry breadcrumbs are diagnostic — if Sentry is unavailable or throws,
 * we silently swallow the error rather than disrupting the user experience.
 *
 * Collaborators: @sentry/react, ClientSentryProvider
 */
import * as Sentry from '@sentry/react';

export function addBreadcrumb(breadcrumb: {
  category: string;
  message: string;
  level?: 'info' | 'warning' | 'error';
  data?: Record<string, unknown>;
}): void {
  try {
    Sentry.addBreadcrumb(breadcrumb);
  } catch {
    // Sentry not initialized or breadcrumb call failed — silently swallow.
    // Breadcrumbs are diagnostic; never let them crash the app.
  }
}
